import { Pipe, PipeTransform } from '@angular/core';
import { PipeHelper } from './pipe-helper';

@Pipe({
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {

  transform = (value: any,  rate: any, length: number): string  =>
     PipeHelper.formatPercentage(value || '', rate || '', length);

}
